import * as S from './Progress.styled';

interface ProgressProps {
  totalSteps: number;
  currentStep: number;
}

export default function Progress({ totalSteps, currentStep }: ProgressProps) {
  return (
    <S.Container>
      {Array.from({ length: totalSteps }).map((_, index) => {
        const percentage =
          index < Math.floor(currentStep) ? 100 : (currentStep - index) * 100;

        return (
          <S.ProgressList key={`step_${index + 1}`} percentage={percentage} />
        );
      })}
    </S.Container>
  );
}
